import { Container, Grid } from "@material-ui/core";
import { useContext } from "react";
import { FaturamentoContratoContext } from "../contexts/FaturamentoContratoContext";
import {
  TypographyStyled,
  InputBaseMonetaryTotal,
  TotalDiv,
  TypographyStyledTotal,
  CardGroupTax,
  InputBaseDecimalErpStyled,
  BtnToInvoice,
  GridStyledGroupInfo,
  CardStyled,
} from "../styles/GrupoInformacoes";

import { Margin } from "../../../../theme/styles/Utils";
import ExpiredCard from "./ExpiredCard";
import { DateRangeSharp, EventBusy } from "@material-ui/icons";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";

export default function GrupoInformacoesCard() {
  const {
    contracts,
    setContracts,
    reimbursableExpenses,
    setReimbursableExpenses,
    totalLooseItem,
    totalBilling,
    setTotalBilling,
    negativeTaxCnab,
    setNegativeTaxCnab,
    totalTaxCnab,
    setTotalTaxCnab,
    negativeTaxPix,
    setNegativeTaxPix,
    totalTaxPix,
    setTotalTaxPix,
    netTotal,
    setNetTotal,
    totalQyonBank,
    setTotalQyonBank,
    negativeQB,
    setNegativeQB,
    expiredTotal,
    expiringTotal,
    selectedItem,
  } = useContext(FaturamentoContratoContext);

  const { queryParams } = useContext(QueryParamsContext);

  const enableReadjustment = !!(
    !!selectedItem.length &&
    !selectedItem.find(
      (current) =>
        current.contrato?.modalidade === "A" || current.contrato?.status !== "A"
    )
  );

  const handleOpenReadjustmentContract = () => {
    const selectedIds = JSON.stringify(
      selectedItem.map((current) => current.contrato?.id)
    );
    const oldPath = window.location.href;
    window.location.href = `${process.env.REACT_APP_URL_REACT_V2}/view/faturamento/reajustecontrato/${selectedIds}?empresa_cnpj=${queryParams.empresa_cnpj}&usuario_id=${queryParams.usuario_id}&usuario_nome=${queryParams.usuario_nome}&usuario_email=${queryParams.usuario_email}&empresa_id=${queryParams.empresa_id}&gfAccessToken=${queryParams.gfAccessToken}&oldPath=${oldPath}`;
    return;
  };

  return (
    <>
      <Margin top={80}>
        <Container maxWidth="xl">
          <CardStyled>
            <Grid container spacing={2}>
              <Grid item container xs>
                <TypographyStyled>Faturamento</TypographyStyled>
                <CardGroupTax chipcolor="transparent" fullWidth={true}>
                  <Grid item container xs style={{ height: "100%" }}>
                    <Grid item container xs={5} spacing={1}>
                      <Grid item>
                        <InputBaseDecimalErpStyled
                          startTag="R$"
                          subtitle="Contratos"
                          disabled={true}
                          value={contracts}
                          setValue={setContracts}
                        />
                      </Grid>
                      <Grid item>
                        <InputBaseDecimalErpStyled
                          startTag="R$"
                          subtitle="Desp. Reemb."
                          disabled={true}
                          value={reimbursableExpenses}
                          setValue={setReimbursableExpenses}
                        />
                      </Grid>
                      <Grid item>
                        <InputBaseDecimalErpStyled
                          startTag="R$"
                          subtitle="Avulsos"
                          disabled={true}
                          value={totalLooseItem}
                        />
                      </Grid>
                    </Grid>

                    <Grid item container xs={7}>
                      <TotalDiv>
                        <Grid
                          item
                          justifyContent="center"
                          align="center"
                          container
                          xs
                        >
                          <Grid item xs={6}>
                            <TypographyStyledTotal>
                              Total Faturamento
                            </TypographyStyledTotal>
                          </Grid>
                          <Grid item xs={12}>
                            <InputBaseMonetaryTotal
                              startTag="R$"
                              disabled={true}
                              value={totalBilling}
                              setValue={setTotalBilling}
                            />
                          </Grid>
                        </Grid>
                      </TotalDiv>
                    </Grid>
                  </Grid>
                </CardGroupTax>
              </Grid>
              <Grid item container xs>
                <TypographyStyled>Reajuste</TypographyStyled>
                <CardGroupTax chipcolor="transparent" fullWidth={true}>
                  <Grid
                    item
                    container
                    xs
                    spacing={2}
                    justifyContent="space-between"
                  >
                    <GridStyledGroupInfo item container spacing={2}>
                      <Grid item xs={6}>
                        <ExpiredCard
                          bottomColor="blue"
                          countDays={expiringTotal}
                          countLabel="À Vencer"
                          bottomDescription="Este Mês"
                          icon={<DateRangeSharp color="primary" />}
                        />
                      </Grid>
                      <Grid item xs={6}>
                        <ExpiredCard
                          bottomColor="red"
                          countDays={expiredTotal}
                          countLabel="Vencidos"
                          bottomDescription="Meses Anteriores"
                          icon={<EventBusy color="error" />}
                        />
                      </Grid>
                    </GridStyledGroupInfo>
                    <Grid
                      item
                      container
                      xs={12}
                      spacing={1}
                      justifyContent="flex-end"
                    >
                      <Grid item container xs={8} md={6} lg={4}>
                        <BtnToInvoice
                          fullWidth={true}
                          label="Reajuste"
                          disabled={!enableReadjustment}
                          onClick={handleOpenReadjustmentContract}
                        />
                      </Grid>
                    </Grid>
                  </Grid>
                </CardGroupTax>
              </Grid>
            </Grid>
          </CardStyled>
        </Container>
      </Margin>
    </>
  );
}
